export const TOKENS = {
  bg: {
    primary: 'var(--bg-primary)',
    elevated: 'var(--bg-elevated)',
    subtle: 'var(--bg-subtle)',
  },
  border: {
    subtle: 'var(--border-subtle)',
    default: 'var(--border-default)',
  },
  text: {
    primary: 'var(--text-primary)',
    secondary: 'var(--text-secondary)',
    tertiary: 'var(--text-tertiary)',
    disabled: 'var(--text-disabled)',
  },
  accent: {
    primary: 'var(--accent-primary)',
    hover: 'var(--accent-hover)',
    muted: 'var(--accent-muted)',
  },
  status: {
    live: 'var(--status-live)',
    exit: 'var(--status-exit)',
    pending: 'var(--status-pending)',
  },
  font: {
    serif: 'var(--font-serif)',
    sans: 'var(--font-sans)',
    mono: 'var(--font-mono)',
  },
  motion: {
    fast: 'var(--motion-fast)',
    base: 'var(--motion-base)',
  },
};
